import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { NgxMaskModule } from 'ngx-mask';

import { TransferComponent } from './transfer.component';
import { BulkAddComponent } from './bulk-add/bulk-add.component';



@NgModule({
  declarations: [
    TransferComponent,
    BulkAddComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    NgxMaskModule.forRoot()
  ]
})
export class TransferModule { }
